import { render } from "./BroadcasterPage.vue?vue&type=template&id=3efa9e52&scoped=true"
import script from "./BroadcasterPage.vue?vue&type=script&lang=js"
export * from "./BroadcasterPage.vue?vue&type=script&lang=js"

import "./BroadcasterPage.vue?vue&type=style&index=0&id=3efa9e52&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa9e52"]])

export default __exports__